import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import './App.css';

import Portal from './Portal.js';
import View from './View.js';
import ViewV2 from './ViewV2.js';
import ViewV3 from './ViewV3.js';
import ViewPanel from './ViewPanel.js';
import * as Constants from "./Constants.js";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      application: Constants.defaultApplication
    };
  }
  
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/viewOld" component={View} />
          <Route path="/viewV2" component={ViewV2} />
          <Route path="/view" component={ViewV3} />
          <Route path="/assets/services/ids/*/results" component={ViewPanel} />
          <Route exact path="/" component={Portal} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;